export default __webpack_public_path__ + "static/media/13.9a691de9.png";